export const BASE_HOUR_SLOT_HEIGHT_PX = 60;

export const DEFAULT_WORKDAY_START_TIME = '08:00';
export const DEFAULT_WORKDAY_END_TIME = '20:00';
export const DEFAULT_BREAK_START_TIME = '12:00';
export const DEFAULT_BREAK_END_TIME = '14:00';
